const NAME_SPACE = 'Accordion';

export { NAME_SPACE };
